
<div class="row background-color-wt">
  <div class="col-print-12 padding-left-0px">
    <div class="card background-color-wt">
      <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

        <div class="row">
          <div class="col-print-12 text-align-center border-bot-1px">
            <label class="margin-bottom-5px font-familyhead">Material Return Note</label>
          </div>
        </div>

        <!--<div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-normal font-familysubhead"></label>
            </div>
            <div class="col-print-6 float-right">
              <label class="margin-bottom-0px font-family font-weight-normal float-right">Date: {{TodayDate | date:'dd-MMM-yyyy'}}</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6 float-left">
              <label class="margin-bottom-0px font-family font-weight-normal float-left">To</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-10 float-left">
              <label class="margin-bottom-0px font-family font-weight-normal float-left">{{SupplierName}}</label>
            </div>
          </div>
        </div>-->
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-12 float-left">
              <label class="margin-bottom-0px font-family font-weight-bold float-left">Details of Returned Material</label>
            </div>
          </div>
        </div>
        <!--<div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4 float-left">
              <label class="margin-bottom-0px font-family font-weight-normal float-left">Date of Return</label>
            </div>:
            <div class="col-print-7 float-left margin-left-10px">
              <label class="margin-bottom-0px font-family font-weight-normal float-left">{{ReturnDate | date:'dd-MMM-yyyy'}}</label>
            </div>
          </div>
        </div>-->
        
        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero border4">
                    <thead>
                      <tr>

                        <th class="font-weight-normal width-120px background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Date
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Material
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Supplier
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Batch
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Return qty
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Reason
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Remarks
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          User
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentPurchaseReturnsController ; let RowIndex = index ">

                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.ReturnDate | date:'dd-MM-yyyy'}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.Description}}
                        </td>

                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.VendorName}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">
                          {{l.BatchNo}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                          {{l.ReturnQuantity}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.Reason}}
                        </td>

                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.Remarks}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.UserName}}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-8">
              <label class="margin-bottom-0px font-family">Prepared By</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Authorized Signatory</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-8">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-7 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center"></label>
                </div>
              </div>
            </div>
            <div class="col-print-4">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-12 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center"></label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--<div class="col-print-12 margin-top-10">
    <div class="row margin-left-0px margin-right-0px">
      <div class="col-print-6 float-left">
        <label class="margin-bottom-0px font-family font-weight-normal float-left">Prepared By</label>
      </div>
      <div class="col-print-6 float-right">
        <label class="margin-bottom-0px font-family font-weight-normal float-right">Authorized Signatory</label>
      </div>
    </div>
  </div>-->
      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
